<header
  class="aes-header noPrint"
  [class.is-rtl]="currentLanguage === 'ar'"
  [class.aes-header-loading]="headerLogicLoading"
>
  <div
    class="aes-header-loader"
    [class.show]="headerLogicLoading"
    aria-live="polite"
  >
    <div class="aes-loader-card">
      <span class="aes-loader-spinner"></span>

      <div>
        <strong>
          {{ currentLanguage === 'ar' ? 'جاري تجهيز القائمة...' : 'Preparing menu...' }}
        </strong>

        <small>
          {{ currentLanguage === 'ar' ? 'تحميل بيانات الحساب واللغة' : 'Loading account and language settings' }}
        </small>
      </div>
    </div>
  </div>

  <nav
    class="atw-header aes-nav"
    aria-label="Main navigation"
    [class.aes-nav-blurred]="headerLogicLoading"
    [attr.aria-busy]="headerLogicLoading"
  >

    <!-- Logo -->
    <a routerLink="/Home" class="brand aes-brand" (click)="closeMobileMenu()">
      <img src="/assets/logo.png" [attr.alt]="'header.logoAlt' | transloco" />
    </a>

    <!-- Mobile Toggle -->
    <button
      class="aes-menu-toggle"
      type="button"
      [class.open]="mobileMenuOpen"
      (click)="toggleMobileMenu()"
      [attr.aria-expanded]="mobileMenuOpen"
      aria-controls="aes-main-menu"
      [disabled]="headerLogicLoading"
    >
      <span></span>
      <span></span>
      <span></span>
    </button>

    <!-- Menu -->
    <div id="aes-main-menu" class="aes-menu" [class.open]="mobileMenuOpen">

      <ul class="header-links aes-links">

        <!-- Home -->
        <li>
          <a
            routerLink="/Home"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            (click)="closeMobileMenu()"
          >
            {{ 'header.home' | transloco }}
          </a>
        </li>

        <!-- For Candidates Dropdown -->
        <li
          *ngIf="showCandidatesMenu()"
          class="aes-dropdown"
          [class.open]="activeDropdown === 'candidates'"
        >
<button
  class="aes-dropdown-trigger"
  type="button"
  [class.active]="
    currentUrl.startsWith('/jobs') ||
    currentUrl.startsWith('/smartapply')
  "
  (click)="toggleDropdown('candidates', $event)"
  [attr.aria-expanded]="activeDropdown === 'candidates'"
  aria-controls="candidates-dropdown-menu"
>
  <span>{{ 'header.forCandidates' | transloco }}</span>

  @if (activeDropdown === 'candidates') {
    <img class="img-s" src="assets/as/6.webp" />
  } @else {
    <img class="img-s" src="assets/as/5.webp" />
  }
</button>

          <div id="candidates-dropdown-menu" class="aes-dropdown-menu">
            <a routerLink="/jobs" (click)="closeMobileMenu()">
                  <img class="img-m" src="assets/as/4.webp" >
              <span>{{ 'header.browsejobs' | transloco }}</span>
            </a>

            <a routerLink="/smartapply" (click)="closeMobileMenu()">
                       <img class="img-m" src="assets/as/8.png" />
              <span>{{ 'header.smartapply' | transloco }}</span>
            </a>
          </div>
        </li>

        <!-- For Employers Dropdown -->
        <li
          *ngIf="showEmployersMenu()"
          class="aes-dropdown"
          [class.open]="activeDropdown === 'employers'"
        >
          <button
            class="aes-dropdown-trigger"
            type="button"
            [class.active]="
              currentUrl.startsWith('/iamhiring') ||
              currentUrl.startsWith('/create-job')
            "
            (click)="toggleDropdown('employers', $event)"
            [attr.aria-expanded]="activeDropdown === 'employers'"
            aria-controls="employers-dropdown-menu"
          >
            <span>{{ 'header.forEmployers' | transloco }}</span>
  @if (activeDropdown === 'employers') {
    <img class="img-s" src="assets/as/6.webp" />
  } @else {
    <img class="img-s" src="assets/as/5.webp" />
  }

          </button>

          <div id="employers-dropdown-menu" class="aes-dropdown-menu">
            <a routerLink="/iamhiring" (click)="closeMobileMenu()">
                 <img class="img-m" src="assets/as/9.webp" >
              <span>{{ 'header.Register' | transloco }}</span>
            </a>

            <a routerLink="/create-job" (click)="closeMobileMenu()">
                   <img class="img-m" src="assets/as/10.webp" >
              <span>{{ 'header.addjob' | transloco }}</span>
            </a>
          </div>
        </li>

        <!-- About Dropdown -->
        <li class="aes-dropdown" [class.open]="activeDropdown === 'about'">
          <button
            class="aes-dropdown-trigger"
            type="button"
            [class.active]="
              currentUrl.startsWith('/about-us') ||
              currentUrl.startsWith('/services') ||
              currentUrl.startsWith('/policies') ||
              currentUrl.startsWith('/contact') ||
              currentUrl.startsWith('/blogs')
            "
            (click)="toggleDropdown('about', $event)"
            [attr.aria-expanded]="activeDropdown === 'about'"
            aria-controls="about-dropdown-menu"
          >
            <span>{{ 'header.aboutUs' | transloco }}</span>
  @if (activeDropdown === 'about') {
    <img class="img-s" src="assets/as/6.webp" />
  } @else {
    <img class="img-s" src="assets/as/5.webp" />
  }

          </button>

          <div id="about-dropdown-menu" class="aes-dropdown-menu">
            <a routerLink="/about-us" (click)="closeMobileMenu()">
                       <img class="img-m" src="assets/as/11.webp" >
              <span>{{ 'header.whoweare' | transloco }}</span>
            </a>

            <a routerLink="/services" (click)="closeMobileMenu()">
           <img class="img-m" src="assets/as/13.webp" >
              <span>{{ 'header.ourServices' | transloco }}</span>
            </a>

            <a routerLink="/policies" (click)="closeMobileMenu()">
            <img class="img-m" src="assets/as/40.webp" >
              <span>{{ 'header.policies' | transloco }}</span>
            </a>

            <a routerLink="/contact" (click)="closeMobileMenu()">
            <img class="img-m" src="assets/as/25.webp" >
              <span>{{ 'header.contactus' | transloco }}</span>
            </a>

            <a routerLink="/blogs" (click)="closeMobileMenu()">
            <img class="img-m" src="assets/as/24.webp" >
              <span>{{ 'header.blog' | transloco }}</span>
            </a>
          </div>
        </li>

<ng-container *ngIf="authReady">
  <!-- Login -->
  <li *ngIf="showLoginButton">
    <a
      routerLink="/Login"
      routerLinkActive="active"
      (click)="closeMobileMenu()"
    >
      {{ 'header.login' | transloco }}
    </a>
  </li>

  <!-- Profile Dropdown -->
  <li
    *ngIf="showProfileButton"
    class="aes-dropdown"
    [class.open]="activeDropdown === 'profile'"
  >
    <button
      class="aes-dropdown-trigger aes-profile-trigger"
      type="button"
      [class.active]="
        currentUrl.startsWith('/profile') ||
        currentUrl.startsWith('/companyprofile') ||
        currentUrl.startsWith('/addreview') ||
        currentUrl.startsWith('/applyed') ||
        currentUrl.startsWith('/Mychats') ||
        currentUrl.startsWith('/myjobs') ||
        currentUrl.startsWith('/change-password')
      "
      (click)="toggleDropdown('profile', $event)"
      [attr.aria-expanded]="activeDropdown === 'profile'"
      aria-controls="profile-dropdown-menu"
    >
      <span>
        <img class="img-m" src="assets/as/22.webp" />
        {{ 'header.profile' | transloco }}
      </span>

      <span class="aes-chevron">
        @if (activeDropdown === 'profile') {
          <img class="img-s" src="assets/as/6.webp" />
        } @else {
          <img class="img-s" src="assets/as/5.webp" />
        }
      </span>
    </button>

    <div id="profile-dropdown-menu" class="aes-dropdown-menu aes-profile-menu">
      <a [routerLink]="profileRoute" (click)="closeMobileMenu()">
        <img class="img-m" src="assets/as/22.webp" />
        <span>{{ 'header.myProfile' | transloco }}</span>
      </a>

      <a
        *ngIf="isCandidate()"
        routerLink="/addreview"
        (click)="closeMobileMenu()"
      >
        <img class="img-m" src="assets/as/23.webp" />
        <span>{{ 'header.addReview' | transloco }}</span>
      </a>

      <a
        *ngIf="isCandidate()"
        routerLink="/applyed"
        (click)="closeMobileMenu()"
      >
        <img class="img-m" src="assets/as/30.webp" />
        <span>{{ 'header.myApplies' | transloco }}</span>
      </a>

      <a
        *ngIf="isCompany()"
        routerLink="/myjobs"
        (click)="closeMobileMenu()"
      >
        <img class="img-m" src="assets/as/4.webp" />
        <span>{{ 'header.myJobs' | transloco }}</span>
      </a>

      <a routerLink="/Mychats" (click)="closeMobileMenu()">
        <img class="img-m" src="assets/as/29.webp" />
        <span>{{ 'header.myChats' | transloco }}</span>
      </a>

      <a routerLink="/change-password" (click)="closeMobileMenu()">
        <img class="img-m" src="assets/as/22.webp" />
        <span>{{ 'header.changePassword' | transloco }}</span>
      </a>

      <button
        type="button"
        class="aes-dropdown-logout"
        (click)="logout()"
      >
        <img class="img-m" src="assets/as/20.webp" />
        <span>{{ 'header.logout' | transloco }}</span>
      </button>
    </div>
  </li>
</ng-container>

      </ul>

      <!-- Actions -->
      <div class="aes-actions">

        <button
          class="secondary-action aes-icon-action"
          type="button"
          (click)="openSearchPopup($event)"
          [attr.aria-label]="'header.search' | transloco"
          [disabled]="headerLogicLoading"
        >
          <img src="/assets/Search_Icons_UIA.png" [attr.alt]="'header.search' | transloco" />
        </button>

        <button
          class="secondary-action aes-lang"
          type="button"
          (click)="toggleLanguage()"
          [disabled]="headerLogicLoading"
        >
          <img src="/assets/lang.png" [attr.alt]="'header.language' | transloco" />

          <span>
            {{
              currentLanguage === 'en'
                ? ('header.langEn' | transloco)
                : ('header.langAr' | transloco)
            }}
          </span>
        </button>

<a
  [routerLink]="applyButtonRoute"
  class="header-btn aes-apply"
  (click)="closeMobileMenu()"
>
  {{ applyButtonLabelKey | transloco }}
</a>

      </div>
    </div>

  </nav>
</header>

<div
  class="aes-search-overlay noPrint"
  [class.open]="searchPopupOpen"
  (click)="closeSearchPopup()"
>
  <div
    class="aes-search-popup"
    [class.is-rtl]="currentLanguage === 'ar'"
    (click)="$event.stopPropagation()"
  >
    <button
      type="button"
      class="aes-search-close"
      (click)="closeSearchPopup()"
      [attr.aria-label]="'header.closeSearch' | transloco"
    >
      ×
    </button>

    <div class="aes-search-head">
      <span class="aes-search-icon">
        <img src="/assets/Search_Icons_UIA.png" [attr.alt]="'header.search' | transloco" />
      </span>

      <div>
        <h3>{{ 'header.searchTitle' | transloco }}</h3>
        <p>{{ 'header.searchSubtitle' | transloco }}</p>
      </div>
    </div>

    <form class="aes-search-form" (submit)="submitSearch($event)">
      <input
        type="text"
        [value]="searchTitle"
        (input)="onSearchInput($event)"
        [placeholder]="'header.searchPlaceholder' | transloco"
        [attr.dir]="currentLanguage === 'ar' ? 'rtl' : 'ltr'"
        [class.is-rtl]="currentLanguage === 'ar'"
        autocomplete="off"
      />

      <button
        type="submit"
        class="primary-action aes-search-submit"
      >
        <span class="aes-search-submit-content">
          <span
            class="aes-search-submit-text"
            [class.text-is-rtl]="currentLanguage === 'ar'"
          >
            {{ 'header.searchButton' | transloco }}
          </span>

        </span>
      </button>
    </form>
  </div>
</div>
